/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostOrdersOrderIdGiveMutationResponse, PostOrdersOrderIdGivePathParams, PostOrdersOrderIdGive400 } from "../entities/PostOrdersOrderIdGive";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { postOrdersOrderIdGive } from "../api/postOrdersOrderIdGive";
import { useMutation } from "@tanstack/react-query";

export const postOrdersOrderIdGiveMutationKey = () => [{ url: '/orders/:order_id/give' }] as const

export type PostOrdersOrderIdGiveMutationKey = ReturnType<typeof postOrdersOrderIdGiveMutationKey>

/**
 * @description Ручка "Передал посылку курьеру"
 * @summary Ручка "Передал посылку курьеру"
 * {@link /orders/:order_id/give}
 */
export function usePostOrdersOrderIdGive<TContext>(options: 
{
  mutation?: UseMutationOptions<PostOrdersOrderIdGiveMutationResponse, ResponseErrorConfig<PostOrdersOrderIdGive400>, {order_id: PostOrdersOrderIdGivePathParams["order_id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? postOrdersOrderIdGiveMutationKey()

  return useMutation<PostOrdersOrderIdGiveMutationResponse, ResponseErrorConfig<PostOrdersOrderIdGive400>, {order_id: PostOrdersOrderIdGivePathParams["order_id"]}, TContext>({
    mutationFn: async({ order_id }) => {
      return postOrdersOrderIdGive(order_id, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}